import React, { useState, useEffect } from "react";
import ShortCalendar from "../Calendar/ShortCalendar";
import Tasks from "./Tasks";
import "./Style/hero.css";
import BarLoader from "../Calendar/BarLoader";
export default function HeroMain({ isEdit, setEdit, taskGroups }) {
  const [finishedlevel, setfinishedlevel] = useState(0);
  return (
    <>
      <div className="calenderandprogress">
        <div className="progress">
          <BarLoader progress={finishedlevel} />
        </div>
        <ShortCalendar isEdit={isEdit} setEdit={setEdit} />
      </div>
      <div className="watch"></div>
      <Tasks
        taskGroups={taskGroups}
        isEdit={isEdit}
        setEdit={setEdit}
        setfinishedlevel={setfinishedlevel}
      />
    </>
  );
}
